import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/cashbackUA';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            mode: 'info',
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            loader: true
        };
        this.widgetsHelper = widgetsHelper;
    }

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
        const waitForDOM = () => {
            if (document.getElementsByClassName('anchor_233')[0]) {
                this.scrollToCalcBtn();
            } else {
                requestAnimationFrame(waitForDOM);
            }
        };

        requestAnimationFrame(waitForDOM);
    }

    scrollToCalcBtn() {
        const currentURL = window.location.href;
        if (currentURL.includes('question_12')) {
            this.setState({mode: 'questions'}, () => {
                const targetElement = document.getElementsByClassName('anchor_233')[0];
                if (targetElement) {
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        }
    }

    toggleMode = mode => {
        this.setState({mode: mode});
    };
}
